<template>
  <page-list
    :list="list"
    :columns="columns"
    :singleActions="singleActions"
    :group-actions="groupActions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import i18n from '@/locales'
import { int2Date } from '@Bill/utils'
// import { getDistinctFieldFilter } from '@/utils/common/tableFilter'
import { getRateRulesColumn } from '../utils/columns'

export default {
  name: 'BillRateHistoryList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'BillRateHistoryList',
        resource: 'rates/' + this.data.id + '/history',
        apiVersion: 'v1',
        getParams: this.getParams,
        // filterOptions: {
        //   usage_type: getDistinctFieldFilter({
        //     field: 'usage_type',
        //     label: this.$t('bill.rate.title.usage_type'),
        //     mapper: (data) => {
        //       return data.map(item => {
        //         return {
        //           key: item.key,
        //           label: this.$te(`rate_usage_type.${item.key}`) ? this.$t(`rate_usage_type.${item.key}`) : item.key,
        //         }
        //       })
        //     },
        //   }),
        //   precision: {
        //     label: this.$t('bill.rate.title.precision'),
        //     dropdown: true,
        //     // filter: true,
        //     items: [
        //       { key: 'second', label: this.$t('rate_precision.second') },
        //       { key: 'day', label: this.$t('rate_precision.day') },
        //       { key: 'month', label: this.$t('rate_precision.month') },
        //     ],
        //     // formatter: (val) => {
        //     //   return `precision.equals(${val})`
        //     // },
        //   },
        //   price_type: {
        //     label: this.$t('bill.rate.title.price_type'),
        //     dropdown: true,
        //     // filter: true,
        //     items: [
        //       { key: 'amount', label: this.$t('rate_price_type.amount') },
        //       { key: 'amount_range', label: this.$t('rate_price_type.amount_range') },
        //       { key: 'fixed_range', label: this.$t('rate_price_type.fixed_range') },
        //     ],
        //     // formatter: (val) => {
        //     //   return `price_type.equals(${val})`
        //     // },
        //   },
        // },
        noPreLoad: true,
        hiddenColumns: ['created_at'],
      }),
      columns: [
        {
          field: 'usage_type',
          title: this.$t('bill.rate.title.usage_type'),
          formatter: ({ row }) => {
            let output = ''
            output += i18n.t(`rate_resource_type.${row.resource_type}`) + '\n'
            if (row.usage_type) {
              output += i18n.t(`rate_usage_type.${row.usage_type}`) + '\n'
            }
            if (row.brand) output += row.brand + '\n'
            if (row.model) output += row.model + '\n'
            if (output) {
              return output
            } else {
              return '-'
            }
          },
        },
        {
          field: 'rate_set',
          title: i18n.t('bill.rate.title.rate_set'),
          width: 100,
          formatter: ({ row }) => {
            if (row.rate_set) {
              return row.rate_set
            } else {
              return '-'
            }
          },
        },
        {
          field: 'precision',
          title: i18n.t('bill.rate.title.precision'),
          width: 100,
          formatter: ({ row }) => {
            if (row.precision) {
              return i18n.t(`rate_precision.${row.precision}`)
            } else {
              return '-'
            }
          },
        },
        {
          field: 'price_type',
          title: i18n.t('bill.rate.title.price_type'),
          width: 140,
          formatter: ({ row }) => {
            if (row.price_type) {
              return i18n.t(`rate_price_type.${row.price_type}`)
            } else {
              return '-'
            }
          },
        },
        getRateRulesColumn(),
        {
          field: 'enable_date',
          title: this.$t('bill.text_162'),
          formatter: ({ row }) => {
            if (row.enable_date && row.until_date) {
              return row.enable_date + ' ~ ' + row.until_date
            } else if (row.enable_date) {
              return row.enable_date
            } else {
              return '-'
            }
          },
        },
        {
          field: 'effective',
          title: this.$t('bill.text_89'),
          showOverflow: 'title',
          slots: {
            default: ({ row }, h) => {
              const enableDate = int2Date(row.enable_date)
              const now = new Date()
              let s = ''
              if (row.effective) {
                s = 'is_effective'
              } else if (enableDate.getTime() > now.getTime()) {
                s = 'is_not_effective'
              } else {
                s = 'is_expire'
              }
              return [
                <div class='text-truncate'>
                  <status status={ s } statusModule="billrate" />
                </div>,
              ]
            },
          },
        },
      ],
      groupActions: [
        {
          label: this.$t('bill.text_169'),
          action: () => {
            this.createDialog('BillRateSetDialog', {
              data: [this.data],
              columns: this.columns,
              onManager: this.onManager,
              refresh: this.refresh,
              type: this.params.options.type,
              rate_id: this.data.id,
              rate_set_id: this.params.options.rateSetId,
              isCreate: true,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
          hidden: () => this.params.options.data.rate_set_id && this.params.options.data.rate_set_id !== this.params.options.rateSetId,
        },
      ],
    }
  },
  created () {
    this.list.fetchData()
    this.initSingleActions()
  },
  methods: {
    getParams () {
      return {
        details: true,
        admin: this.$store.getters.isAdminMode,
        rate_set_id: this.params.options.data.rate_set_id || this.params.options.rateSetId,
      }
    },
    initSingleActions () {
      if (!this.params.options.data.rate_set_id || this.params.options.data.rate_set_id === this.params.options.rateSetId) {
        this.singleActions = [
          {
            label: this.$t('bill.text_165'),
            action: obj => {
              this.createDialog('BillRateSetDialog', {
                data: [obj],
                columns: this.columns,
                onManager: this.onManager,
                refresh: this.refresh,
                type: this.params.options.type,
                rate_id: this.data.id,
                rate_set_id: this.params.options.rateSetId,
              })
            },
            hidden: (obj) => this.params.options.rateSetId !== obj.rate_set_id,
          },
          {
            label: this.$t('bill.text_167'),
            action: obj => {
              this.createDialog('BillRateDeleteDialog', {
                data: [obj],
                columns: this.columns,
                title: this.$t('bill.text_167'),
                name: this.$t('bill.text_37'),
                rate_id: this.data.id,
                rate_set_id: this.params.options.rateSetId,
                success: () => {
                  this.refresh()
                },
              })
            },
            hidden: (obj) => this.params.options.rateSetId !== obj.rate_set_id,
          },
        ]
      }
    },
    refresh () {
      this.list.refresh()
      this.$bus.$emit('refreshRateList')
    },
  },
}
</script>
